import { createParser, useQueryState } from 'nuqs';
import React, { useTransition } from 'react';

import { TransmissionTypeList } from '@/services/filters/new-filters.service';

import { isFilterEqual, useResetPage } from '../../utils';
import { FilterBlockGroup } from '../common/filter-block-group';

export const NewTransmissionFilter: React.FC<{
  transmissionTypes: TransmissionTypeList;
  searchQuery?: string;
  setSearchQuery?: (query: string) => void;
}> = ({ transmissionTypes, searchQuery, setSearchQuery }) => {
  const [, startTransition] = useTransition();

  const resetPage = useResetPage();

  const [queryTransmissionTypes, setQueryTransmissionTypes] = useQueryState(
    'transmission',
    createParser({
      parse: (value) => {
        const selected = value ? value.toLowerCase().split(',') : [];

        return transmissionTypes.map((type) => ({
          ...type,
          isSelected: selected.includes(type.name.toLowerCase()),
        }));
      },
      serialize: (value) =>
        value
          .filter((item) => item.isSelected)
          .map((item) => item.name)
          .join(','),
      eq: isFilterEqual,
    })
      .withDefault(
        transmissionTypes.map((type) => ({
          ...type,
          isSelected: false,
        })),
      )
      .withOptions({
        shallow: false,
        history: 'replace',
        startTransition,
      }),
  );

  const handleSelect = (filter: (typeof queryTransmissionTypes)[number]) => {
    // If user manually toggles, clear search (existing UX)
    if (filter.isSelected && searchQuery && setSearchQuery) {
      setSearchQuery('');
    }

    // Reset page to 1 when transmission filters change
    resetPage();

    setQueryTransmissionTypes(
      queryTransmissionTypes.map((item) =>
        item.id === filter.id
          ? { ...item, isSelected: !item.isSelected }
          : item,
      ),
    );
  };

  return (
    <FilterBlockGroup
      label="Transmission"
      filters={queryTransmissionTypes}
      onSelect={handleSelect}
    />
  );
};
